import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import TextInput from '../../Components/TextInput';
import SnippetService from '../../Services/SnippetService';
import Button from '../../Components/Button';
import SuccessAlert from '../../Components/SuccessAlert';
import ClickCopyLabel from '../../Components/ClickCopyLabel';
import StringUtils from '../../Utils/StringUtils';
import Header from '../../Components/Heading';
import { NotificationManager } from 'react-notifications';

const snippetType = 'FeaturedParagraphSnippet';

export default function FeaturedParagraphSnippet() {
	const [ enable, setEnable ] = useState(true);
	const [ res, setRes ] = useState(null);

	const formik = useFormik({
		initialValues,
		validationSchema,
		onSubmit: (values, { resetForm }) => {
			processSubmit(setEnable, values, setRes, resetForm);
		}
	});
	useEffect(
		() => {
			if (res && res.success) {
				NotificationManager.success(`Created ${res.snippetId}`);
				formik.setValues({ ...initialValues });
				formik.resetForm({ ...initialValues });
			} else if (res && !res.success) {
				NotificationManager.error(res.message);
			}
		},
		[ res ]
	);
	return (
		<div className="grid justify-items-center">
			<Header text="Create Featured Paragraph Snippet" type="h2" />
			{res &&
			res.success && (
				<SuccessAlert>
					<div className="flex items-center">
						<ClickCopyLabel text={res.snippetId} label="Snippet Id" />
					</div>
				</SuccessAlert>
			)}

			<form className="w-4/5">
				<TextInput
					label="Text"
					placeholder="Text"
					name="text"
					onChange={formik.handleChange}
					value={formik.values.text}
					disabled={!enable}
					error={formik.errors.text}
				/>
				<TextInput
					label="Comments"
					placeholder="Comments"
					name="comments"
					onChange={formik.handleChange}
					value={formik.values.comments}
					disabled={!enable}
					error={formik.errors.comments}
				/>
				<Button text="Submit" disabled={!enable} type="submit" onClick={formik.handleSubmit} />
			</form>
		</div>
	);
}

function processSubmit(setEnable, values, setRes, resetForm) {
	setEnable(false);
	SnippetService.createSnippet({
		snippetType,
		...values
	})
		.then((res) => {
			setRes({
				snippetId: StringUtils.wrapSnippetId(res),
				success: true
			});
			resetForm();
			setEnable(true);
		})
		.catch((e) => {
			console.error('ERROR');
			console.error(e);
		});
}

const validationSchema = Yup.object().shape({
	text: Yup.string().required('Required'),
	comments: Yup.string().nullable()
});

const initialValues = {
	text: null,
	comments: null
};
